export enum giftCardActionTypes {
    FETCH_GIFT_CARD = "@@giftCard/FETCH_GIFT_CARD",
}

export interface giftCardStateInterface {
    product: object
}
